// Режим панели списка на карте для мобильного (< 768px):
//   sheet  - нижняя выдвижная панель (bottom sheet), как было всегда, дефолт
//   drawer - «рейка + шторка»: компактная вкладка слева, по тапу шторка поверх карты
// Хранится в localStorage per-device (как тема и режим меню). Сам режим применяет
// SidePanel.vue, и только на страницах, которые передали prop mobileDrawer
// (Транспорт, Геозоны): остальные страницы работают в sheet-режиме независимо от
// настройки, чтобы новый режим не задел никого, кто его не включал.

const STORAGE_KEY = 'mobilePanel'
const WIDTH_KEY = 'mobilePanelWidth'
const DEFAULT_MODE = 'sheet'
export const MOBILE_PANEL_MODES = ['sheet', 'drawer']
// Пределы ширины колонки в долях ширины экрана (иначе карта или список теряют смысл)
export const MOBILE_PANEL_WIDTH_MIN = 0.4
export const MOBILE_PANEL_WIDTH_MAX = 0.9

const listeners = new Set()

function getStoredMode() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return MOBILE_PANEL_MODES.includes(raw) ? raw : DEFAULT_MODE
  } catch {
    return DEFAULT_MODE
  }
}

// Текущий выбор пользователя (sheet|drawer).
export function getMobilePanel() {
  return getStoredMode()
}

// Меняет режим: сохраняет в localStorage и оповещает подписчиков (SidePanel).
export function setMobilePanel(mode) {
  if (!MOBILE_PANEL_MODES.includes(mode)) {
    throw new Error(`Invalid mobile panel mode: ${mode}`)
  }
  localStorage.setItem(STORAGE_KEY, mode)
  notify(mode)
}

// --- Ширина колонки (px), настраивается перетаскиванием правого края в SidePanel ---
// Хранится per-device; применяется CSS-переменной --mobile-drawer-width на <html>,
// её читают и колонка (SidePanel), и попап на карте (DevicesPage). Без сохранённого
// значения действует дефолт из style.css (min(60vw, 280px)).
function clampWidth(px) {
  if (typeof window === 'undefined') return px
  const min = Math.round(window.innerWidth * MOBILE_PANEL_WIDTH_MIN)
  const max = Math.round(window.innerWidth * MOBILE_PANEL_WIDTH_MAX)
  return Math.max(min, Math.min(max, Math.round(px)))
}

export function getMobilePanelWidth() {
  try {
    const v = parseInt(localStorage.getItem(WIDTH_KEY), 10)
    return Number.isFinite(v) && v > 0 ? v : null
  } catch {
    return null
  }
}

// Применяет ширину к документу без сохранения (во время перетаскивания).
export function applyMobilePanelWidth(px = getMobilePanelWidth()) {
  if (typeof document === 'undefined') return
  if (px) {
    document.documentElement.style.setProperty('--mobile-drawer-width', `${clampWidth(px)}px`)
  } else {
    document.documentElement.style.removeProperty('--mobile-drawer-width')
  }
}

// Сохраняет ширину (конец перетаскивания) и применяет.
export function setMobilePanelWidth(px) {
  const w = clampWidth(px)
  localStorage.setItem(WIDTH_KEY, String(w))
  applyMobilePanelWidth(w)
}

// Инициализация - один раз на старте приложения (восстанавливает ширину).
export function initMobilePanel() {
  applyMobilePanelWidth()
}

// Подписка на смену режима - SidePanel переключается без перезагрузки страницы.
export function subscribe(callback) {
  listeners.add(callback)
  return () => listeners.delete(callback)
}

function notify(mode) {
  listeners.forEach((cb) => {
    try {
      cb(mode)
    } catch (e) {
      console.error('[mobilePanelService] listener error:', e)
    }
  })
}
